module.exports = __webpack_public_path__ + "img/partnership.aed425af.png";